var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpitedTimeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172,
    height: 172,
    viewBox: "0 0 172 172",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17673_65977)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_17673_65977)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41 135.985C23.8507 135.455 10 121.356 10 104C10 87.6978 22.2196 74.2692 37.9147 72.2597C43.8959 51.3194 63.1992 36 86 36C113.554 36 136 58.372 136 86L136 86.0197C136.332 86.0066 136.665 86 137 86C150.756 86 162 97.1779 162 111C162 124.822 150.756 136 137 136C136.665 136 136.332 135.993 136 135.98V136H41V135.985Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M42 136C59.6077 136 74 121.692 74 104C74 86.3077 59.6077 72 42 72C24.3923 72 10 86.3077 10 104C10 121.692 24.3923 136 42 136Z",
    fill: "url(#paint0_linear_17673_65977)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137 136C150.756 136 162 124.822 162 111C162 97.1779 150.756 86 137 86C123.244 86 112 97.1779 112 111C112 124.822 123.244 136 137 136Z",
    fill: "url(#paint1_linear_17673_65977)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86 136C113.554 136 136 113.628 136 86C136 58.372 113.554 36 86 36C58.4462 36 36 58.372 36 86C36 113.628 58.3118 136 86 136Z",
    fill: "url(#paint2_linear_17673_65977)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8235 78.0136L77.4299 75.4014C78.19 74.6395 78.19 73.3333 77.4299 72.5714C76.6697 71.8095 75.3665 71.8095 74.6063 72.5714L72 75.1837L69.3937 72.5714C68.6335 71.8095 67.3303 71.8095 66.5701 72.5714C65.81 73.3333 65.81 74.6395 66.5701 75.4014L69.1765 78.0136L66.5701 80.6259C65.81 81.3878 65.81 82.6939 66.5701 83.4558C67.0045 83.8912 67.4389 84 67.9819 84C68.5249 84 68.9593 83.7823 69.3937 83.4558L72 80.8435L74.6063 83.4558C75.0407 83.8912 75.4751 84 76.0181 84C76.5611 84 76.9955 83.7823 77.4299 83.4558C78.19 82.6939 78.19 81.3878 77.4299 80.6259L74.8235 78.0136Z",
    fill: "#3370FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.824 78.0136L105.43 75.4014C106.19 74.6395 106.19 73.3333 105.43 72.5714C104.67 71.8095 103.367 71.8095 102.606 72.5714L100 75.1837L97.3937 72.5714C96.6335 71.8095 95.3303 71.8095 94.5701 72.5714C93.81 73.3333 93.81 74.6395 94.5701 75.4014L97.1765 78.0136L94.5701 80.6259C93.81 81.3878 93.81 82.6939 94.5701 83.4558C95.0045 83.8912 95.4389 84 95.9819 84C96.5249 84 96.9593 83.7823 97.3937 83.4558L100 80.8435L102.606 83.4558C103.041 83.8912 103.475 84 104.018 84C104.561 84 104.995 83.7823 105.43 83.4558C106.19 82.6939 106.19 81.3878 105.43 80.6259L102.824 78.0136Z",
    fill: "#3370FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69,
    y: 96,
    width: 32,
    height: 4,
    rx: 2,
    fill: "#3370FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89 100H97V104C97 106.209 95.2091 108 93 108C90.7909 108 89 106.209 89 104V100Z",
    fill: "#3370FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 28.8281,
    width: 4,
    height: 24,
    rx: 2,
    transform: "rotate(-45 32 28.8281)",
    fill: "#3370FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 46.8633,
    width: 4,
    height: 16,
    rx: 2,
    transform: "rotate(-75 29 46.8633)",
    fill: "#3370FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 30.0352,
    width: 4,
    height: 10,
    rx: 2,
    transform: "rotate(-15 52 30.0352)",
    fill: "#3370FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_17673_65977",
    x: -14,
    y: 24,
    width: 200,
    height: 148,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 12
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0823529 0 0 0 0 0.368627 0 0 0 0 0.937255 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_17673_65977"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0823529 0 0 0 0 0.368627 0 0 0 0 0.937255 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_17673_65977",
    result: "effect2_dropShadow_17673_65977"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_17673_65977",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17673_65977",
    x1: 6.59468,
    y1: 65.1105,
    x2: 35.1107,
    y2: 96.1492,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9942,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_17673_65977",
    x1: 109.34,
    y1: 80.6175,
    x2: 131.618,
    y2: 104.867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9942,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_17673_65977",
    x1: 30.6792,
    y1: 25.2351,
    x2: 75.2355,
    y2: 73.7331,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADC6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9942,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17673_65977"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 172,
    height: 172,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpitedTimeLogo);
export default __webpack_public_path__ + "static/media/expited-time-logo.31e1c45c5ebc5f8aa632b25e54c4dcce.svg";
export { ForwardRef as ReactComponent };